<template>
    <div class="sa-footer" v-if="!hideMenu">
        <div class="sa-social-footer">
            <a href="https://www.linkedin.com/company/sanar-health-care" target="_blank"><i class="icon-linkedin"></i></a>
            <a href="https://www.facebook.com/sanarksa/" target="_blank"><i class="icon-fb"></i></a>
            <a href="https://twitter.com/sanarksa?s=21" target="_blank" ><i class="icon-twitter"></i></a>
            <a href="https://www.instagram.com/sanarksa/?hl=en" target="_blank"><i class="icon-instagram"></i></a>
            <a href="https://youtube.com/channel/UCPMJHVdFwNiI4IAMCjR6eWw" target="_blank"><i class="icon-youtube"></i></a>
        </div>
        <div class="sa-footer-list">
            <span v-if="userInfo">
              <a href="javascript:void(0);">© {{ new Date().getFullYear() }} Sanar</a>
              <a href="javascript:void(0);"> V 0.0.1 </a>
              <component :is="navigate ? 'router-link' : 'button'" :to="navigate ? '/privacy-policy' : undefined">Privacy Policy</component>
              <component :is="navigate ? 'router-link' : 'button'" :to="navigate ? '/terms-and-conditions' : undefined">Terms and Conditions</component>
            </span>
            <span v-else>
              <a href="javascript:void(0);">© {{ new Date().getFullYear() }} Sanar</a>
              <a href="javascript:void(0);"> V 0.0.1   </a>
            </span>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
  export default {
    data() {
      return {
        userInfo:null
        // navigate: false
      };
    },
    watch: {
   '$store.state.userdata': {
          immediate: true,
          deep: true,
          handler () {
            this.userInfo =  JSON.parse(this.$localStorage.get("userdata"))
          }
    }
  },
    computed: mapState(['navigate', 'hideMenu']),
  };
</script>
